<template>
    <page>
      <div>
        <v-flex xs12>
          <form action="">
            <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> Filters
                </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md6>
                          <v-autocomplete :label="labels.ifrsClsGrp" :items="ifrsClsGrpList" v-model="filters.ifrsClsGrp" item-text="value" item-value="code" data-vv-name="ifrsClsGrp" :data-vv-as="labels.ifrsClsGrp" :error-messages="errors.collect('ifrsClsGrp')"></v-autocomplete>
                        </v-flex>
                        <v-flex md6>
                          <v-autocomplete :label="labels.ifrsClsGrpDesc" :items="ifrsClsGrpDescList" v-model="filters.ifrsClsGrpDesc" item-text="value" item-value="code" data-vv-name="ifrsClsGrpDesc" :data-vv-as="labels.ifrsClsGrpDesc" :error-messages="errors.collect('ifrsClsGrpDesc')"></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          </form>
        </v-flex>
        <v-spacer class="mt-1"></v-spacer>
        <v-card>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-card-title>
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click.native="doNew()">
                New IFRS Class Group
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </v-layout>
          </v-card-title>
          <v-flex xs12>
            <v-card>
              <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
                <template v-slot:item="row"><tr>
                  <td>{{ row.item.ifrsClsGrp }}</td>
                  <td>{{ row.item.ifrsClsGrpDesc }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" review @review="doAction('edit', row.item)" remove @remove="doRemove(row.item)" query @query="doAction('query', row.item)"></table-action>
                  </td>
                </tr></template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card>
        <confirm ref="confirmDelete">
          Are you sure that you want to delete the selected IFRS Class Group?
        </confirm>
        <v-dialog v-model="ifrsClsGrpReview" width="800px" persistent>
          <IFRSClassGroupReview :ifrsClsGrpForm="ifrsClsGrpForm" :menu="menu" :mode="mode" @close="doClose"></IFRSClassGroupReview>
        </v-dialog>
      </div>
    </page>
  </template>
<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { extractMenu } from '@/utils/extract'
import { expandURI, filterQuery } from '@/utils/ajax'
import IFRSClassGroupReview from './IFRSClassGroupReview'
export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'IFRS Class Group', value: 'ifrsClsGrp' },
        { text: 'IFRS Class Group Description', value: 'ifrsClsGrpDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        ifrsClsGrp: 'IFRS Class Group',
        ifrsClsGrpDesc: 'IFRS Class Group Description'
      },
      filters: {
        ifrsClsGrp: undefined,
        ifrsClsGrpDesc: undefined
      },
      ifrsClsGrpForm: {
        ifrsClsGrp: null,
        ifrsClsGrpDesc: null,
        createdName: '',
        createdDate: null,
        modifiedName: '',
        modifiedDate: null
      },
      totalItems: 0,
      deleteIFRS: undefined,
      loading: false,
      ifrsClsGrpList: [],
      ifrsClsGrpDescList: [],
      menu: {},
      mode: '',
      ifrsClsGrpReview: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async doInit() {
      try {
        const apiURI = this.$store.state.busClsParam.menu.getIFRSClsGrpMenu
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.menu = extractMenu(result.data._links)
          }
          this.fetchData(true)
          await this.fetchDataFilter()
        }
      } catch (err) {
        throw err
      }
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getIFRSClsGrpPage
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  ifrsClsGrp: datamap.ifrsClsGrp,
                  ifrsClsGrpDesc: datamap.ifrsClsGrpDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.ifrsClsGrp = undefined
      this.filters.ifrsClsGrpDesc = undefined
      this.pagination.page = 1
      this.fetchDate(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    async doRemove(item) {
      this.deleteIFRS = item.ifrsClsGrp
      const prompt = await this.$refs.confirmDelete.doPopUp()
      if (!prompt) return
      const apiURI = this.menu.deleteIFRSClsGrp
      if (apiURI) {
        const ifrsClsGrpForm = {
          ifrsClsGrp: item.ifrsClsGrp
        }
        this.$http
          .post(apiURI, ifrsClsGrpForm)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.close()
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
        this.doInit()
      }
    },
    async doAction(mode, listData) {
      const apiURI = this.menu.getIFRSClsGrp
      if (apiURI) {
        try {
          const expand = {
            ifrsClsGrp: listData.ifrsClsGrp
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.ifrsClsGrpForm.ifrsClsGrp = data.ifrsClsGrp.ifrsClsGrp
            this.ifrsClsGrpForm.ifrsClsGrpDesc = data.ifrsClsGrp.ifrsClsGrpDesc
            this.ifrsClsGrpForm.createdName = data.ifrsClsGrp.createdName
            this.ifrsClsGrpForm.createdDate = data.ifrsClsGrp.createdDate
            this.ifrsClsGrpForm.modifiedName = data.ifrsClsGrp.modifiedName
            this.ifrsClsGrpForm.modifiedDate = data.ifrsClsGrp.modifiedDate

            this.mode = mode
            this.ifrsClsGrpReview = true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doNew() {
      this.mode = 'new'
      this.ifrsClsGrpReview = true
    },
    doClose() {
      this.ifrsClsGrpReview = false
      this.fetchData()
    },
    async fetchDataFilter() {
      this.resetMessages()
      const apiURI = this.menu.getIFRSClsGrpFilter
      if (apiURI) {
        try {
          this.loading = true
          const result = await this.$http.get(apiURI)
          if (result) {
            const { data } = result.data
            if (data) {
              data.ifrsClsGrp.map((datamap) => {
                this.ifrsClsGrpList.push(datamap)
              })
              data.ifrsClsGrpDesc.map((datamap2) => {
                this.ifrsClsGrpDescList.push(datamap2)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    }
  },
  computed: {},
  components: {
    IFRSClassGroupReview
  },
  mounted() {
    this.doInit()
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
